import {useEffect} from 'react';

import {useSelector} from '../../state/hooks';
import {useViewer} from '../../state/viewer/hooks';
import {getViewerLoading} from '../../state/viewer/selectors';
import {useAdminModeActive} from '../admin';
import {disableDatadog} from './datadog';
import {setRumUser, startRumSessionReplayRecording} from './datadogRum';

const ANONYMOUS = {id: 'anonymous'} as const;

/**
 * Sets up the Datadog RUM user info when it becomes available.
 * Disables Datadog if the user is detected to be an admin user.
 *
 * Call once near the app root, inside the Redux provider (it reads viewer
 * state).
 */
export function useDatadogUserSetup(): void {
  const isAdmin = useAdminModeActive();
  const viewerIsLoading = useSelector(getViewerLoading);
  const viewer = useViewer();

  useEffect(() => {
    if (isAdmin) {
      disableDatadog();
    }
  }, [isAdmin]);

  useEffect(() => {
    if (viewerIsLoading) {
      return;
    }
    if (viewer) {
      setRumUser({
        // The non-deprecated setUser requires an id; viewer.username is
        // optional in the Viewer type, so fall back to the viewer id.
        id: viewer.username ?? viewer.id,
        name: viewer.name,
      });
      startRumSessionReplayRecording();
    } else {
      setRumUser(ANONYMOUS);
    }
  }, [viewerIsLoading, viewer]);
}
